import Vue from 'vue'
import Router from 'vue-router'
import WebLayout from '../components/WebLayout'
import ResultGame from '../components/ResultGame.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      name: 'web-layout',
      path: '*',
      component: WebLayout,
      children: [
        {
          name: 'result-game',
          path: '/result',
          component: ResultGame,
        },
      ]
    },
  ],
})

export default router
